import type { ReactNode } from 'react';

import { useGetFolderList } from 'features/chat/hooks/use-kb';

import { AgentConfigFolderCard } from './agents-config-folder-card';

type AgentConfigFolderListProps = {
  projectKey: string;
  selectedFolderIds: string[];
  onRemove: (folderId: string) => void;
  disabled?: boolean;
  emptyState: ReactNode;
};

/** The agent's knowledge folders, or `emptyState` when none is selected. */
export function AgentConfigFolderList({
  projectKey,
  selectedFolderIds,
  onRemove,
  disabled = false,
  emptyState,
}: AgentConfigFolderListProps) {
  const { data: folderListData } = useGetFolderList(projectKey, !!projectKey);
  const folders = folderListData?.data?.folders || [];
  const selectedFolders = folders.filter((folder) => selectedFolderIds.includes(folder._id));

  if (selectedFolders.length === 0) return <>{emptyState}</>;

  return (
    <div className="grid max-h-[40vh] gap-4 overflow-y-auto">
      {selectedFolders.map((folder) => (
        <AgentConfigFolderCard
          key={folder._id}
          folder={folder}
          onRemove={onRemove}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
